//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppFooter',

  computed: {
    hideFooter() {
      const path = this.$route.path.split('/')

      return (
        ['recommendations', 'checkout'].some(i => path[1] === i) ||
        ['quiz', 'register'].some(i => path[2] === i)
      )
    }
  }
}
